import { API_ENV } from '@kurotetsu/agent/apis/fetchUtils';
import kurotetsuLogo from '@kurotetsu/agent/assets/kurotetsu_logo.jpg';
import { logout } from '@kurotetsu/agent/vendors/firebase';
import LayoutUser from '@kurotetsu/share/components/LayoutUser';
import { useAuth } from '@kurotetsu/share/context/AuthContext';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './layoutHeader.module.css';

const isProd = API_ENV === 'production';

const Header: React.FC = () => {
  const { t } = useTranslation();
  const { user, logout: authLogout } = useAuth();

  const handleLogout = async () => {
    await logout();
    authLogout();
  };

  return (
    <header className={styles.header}>
      <div className={styles.inner}>
        <a href="/dashboard" className={styles.logo}>
          <img
            src={kurotetsuLogo}
            alt={t('common.title')}
            style={{ height: '40px' }}
          />
          {!isProd && (
            <h4 className={styles.notProd}>{`代理店・営業所 ${API_ENV}`}</h4>
          )}
        </a>
        {user && <LayoutUser email={user.email} onLogout={handleLogout} />}
      </div>
    </header>
  );
};

export default Header;
